module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center-textst"
  }, [_vm._v("“Nothing can be compared to the new life that the discovery of another country provides for a thoughtful person. Although I am still the same I believe to have changed to the bones.”")]), _vm._v(" "), _c('p', {
    staticClass: "center-texts"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Johann Wolfgang van Goethe")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TALIAN")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURNEY")]), _vm._v(",")]), _vm._v(" 1816")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 72
// module chunks = 0